export const NURSERY_PRODUCT_TYPE_HIERARCHY_WILDCARDS = [
  "PRODUCT.Home & Garden.Nursery Equipment & Furniture.*",
  "PRODUCT.Clothing & Accessories.Children's Clothing.Babywear.*",
  "PRODUCT.Sports Equipment & Leisure.Toys & Games.Nursery Toys.*",
  "PRODUCT.Technology.Home and Personal Security.Smart Home Monitoring and Sensor",
];

type ProductTypeHierarchyCarrier = {
  productTypeHierarchy?: unknown;
  sellingProductType?: unknown;
};

export function getProductTypeHierarchy(
  product: ProductTypeHierarchyCarrier | null | undefined,
): string | undefined {
  const productTypeHierarchy = product?.productTypeHierarchy;
  const sellingProductType = product?.sellingProductType;

  const hierarchy =
    typeof productTypeHierarchy === "string" ? productTypeHierarchy : undefined;
  const sellingType =
    typeof sellingProductType === "string" ? sellingProductType : undefined;

  if (hierarchy && sellingType) {
    return `${hierarchy}.${sellingType}`;
  }

  return hierarchy ?? sellingType;
}

function normalizeWildcardPrefix(wildcard: string): string {
  return wildcard.endsWith(".*") ? wildcard.slice(0, -2) : wildcard;
}

export function matchesProductTypeHierarchyWildcard(
  productTypeHierarchy: string | null | undefined,
  wildcard: string,
): boolean {
  if (!productTypeHierarchy) return false;

  const prefix = normalizeWildcardPrefix(wildcard);
  return (
    productTypeHierarchy === prefix ||
    productTypeHierarchy.startsWith(`${prefix}.`)
  );
}

export function matchesAnyProductTypeHierarchyWildcard(
  productTypeHierarchy: string | null | undefined,
  wildcards: string[],
): boolean {
  return wildcards.some((wildcard) =>
    matchesProductTypeHierarchyWildcard(productTypeHierarchy, wildcard),
  );
}

export function isNurseryProductTypeHierarchy(
  productTypeHierarchy: string | null | undefined,
): boolean {
  return matchesAnyProductTypeHierarchyWildcard(
    productTypeHierarchy,
    NURSERY_PRODUCT_TYPE_HIERARCHY_WILDCARDS,
  );
}
